import { BaseError } from '@kiplin/web-common/error';

export class MissingCurrentClientUserClientError extends BaseError {
  public constructor(clientId: string) {
    super(
      'b5b7f8c6-0a31-4f7a-9e1a-8f10c2c0f4d1',
      `CurrentClientUser - Try to access client "${clientId}" but it is undefined`,
    );
  }
}
